import { render, staticRenderFns } from "./infomsg.vue?vue&type=template&id=1e107ff4&scoped=true&"
import script from "./infomsg.vue?vue&type=script&lang=js&"
export * from "./infomsg.vue?vue&type=script&lang=js&"
import style0 from "./infomsg.vue?vue&type=style&index=0&id=1e107ff4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e107ff4",
  null
  
)

export default component.exports